/**
 * Klantstem — Bouwbrief 07.
 *
 * Wisselen tussen de ingevulde stemmen. Bewust géén automatisch doorschuiven:
 * dat leest voor langzame lezers weg voordat ze klaar zijn, en zonder
 * pauzeknop is dat een WCAG-probleem (2.2.2). Wie het ooit toch wil, bouwt er
 * eerst die pauzeknop bij.
 */

class MivozaVoice extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onKlik);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onKlik);
  }

  #onKlik = (event) => {
    const knop = event.target instanceof Element ? event.target.closest('[data-voice-dot]') : null;
    if (!knop) return;
    this.#toon(Number(knop.dataset.voiceDot));
  };

  #toon(nummer) {
    for (const item of this.querySelectorAll('[data-voice-item]')) {
      item.hidden = Number(item.dataset.voiceItem) !== nummer;
    }

    for (const dot of this.querySelectorAll('[data-voice-dot]')) {
      const aan = Number(dot.dataset.voiceDot) === nummer;
      dot.classList.toggle('is-on', aan);
      // aria-current en niet aria-selected: dit zijn losse knoppen, geen tabs.
      if (aan) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    }
  }
}

if (!customElements.get('mivoza-voice')) {
  customElements.define('mivoza-voice', MivozaVoice);
}
